// 🧹 PAYLOAD DE EDIÇÃO PARA O FIRESTORE — B338 (AI_149)
// ─────────────────────────────────────────────────────────────
// Por que existe: o Firestore REJEITA `undefined`, então o app filtrava os campos
// undefined antes do `updateDoc`. Só que a tela usa `undefined` justamente para
// dizer **"o médico limpou esta célula"** — e o filtro fazia o campo sumir do
// payload: o update não mexia nele e o valor VELHO permanecia, sem erro nenhum.
//
// Achado ao vivo por Leonardo (28/07/2026): não conseguia apagar uma albumina de
// 0,1 g/dL (valor emitido errado pelo laboratório, num paciente hígido). Pior: o
// MELD 3.0 trava a albumina no piso 1,5, então esse 0,1 inflava o score.
//
// A forma certa de APAGAR um campo no Firestore é `deleteField()`. Este helper
// traduz a intenção da tela em payload, mantendo fora os campos imutáveis (B81:
// `criadoEm` volta convertido da tela e a regra negaria o update inteiro).
// A `sentinelaApagar` é injetada para o módulo ficar puro e testável sem o SDK.
// ─────────────────────────────────────────────────────────────

/**
 * Monta o payload de `updateDoc`: valor presente vira valor; `undefined` vira a
 * sentinela de exclusão; campo bloqueado fica de fora.
 *
 * @param dados            o que a tela quer gravar (undefined = apagar).
 * @param bloqueados       campos imutáveis/meta que nunca vão no payload.
 * @param sentinelaApagar  fábrica da marca de exclusão (no app: `deleteField`).
 */
export function montarPayloadEdicao(
  dados: Record<string, unknown>,
  bloqueados: Set<string>,
  sentinelaApagar: () => unknown
): Record<string, unknown> {
  const payload: Record<string, unknown> = {};
  for (const [chave, valor] of Object.entries(dados || {})) {
    if (bloqueados.has(chave)) continue;
    payload[chave] = valor === undefined ? sentinelaApagar() : valor;
  }
  return payload;
}
